import type {Reminder} from 'types/entities/Reminder'
import type {MonthDataResponse} from 'types/responses/MonthDataResponse'
import dayjs from 'dayjs'

export interface ConfirmedCalendarReminder {
    reminder: Reminder
    revision: number
    deleted?: boolean
}
export interface CalendarReminderScope {
    sellerId: number
    hallId: number
}

export function reconcileCalendarReminders(month: MonthDataResponse | null, confirmed: Record<number, ConfirmedCalendarReminder>, scope: CalendarReminderScope | null): MonthDataResponse | null {
    if (!month || !scope || Object.keys(confirmed).length === 0) return month
    const saved = Object.values(confirmed).filter(entry => !entry.deleted).map(entry => entry.reminder)
    return {...month, days: month.days.map(day => {
        // Remove previous versions before inserting: edits may move a reminder
        // to another date, seller or hall. Never duplicate the cached version.
        const reminders = (day.reminders ?? []).filter(reminder => !confirmed[reminder.id])
        for (const reminder of saved) {
            if (!reminder.deleted_at && reminder.seller_id === scope.sellerId
                && reminder.hall_id === scope.hallId && reminder.due_at
                && dayjs(reminder.due_at).isValid()
                && dayjs(reminder.due_at).isSame(dayjs(day.date), 'day')) reminders.push(reminder)
        }
        reminders.sort((a, b) => new Date(a.due_at).getTime() - new Date(b.due_at).getTime() || a.id - b.id)
        return {...day, reminders}
    })}
}
